import listActions from 'src/modules/userData/list/userDataListActions';
import UserDataService from 'src/modules/userData/userDataService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'USERDATA_DESTROY';

const userDataDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userDataDestroyActions.DESTROY_STARTED,
      });

      await UserDataService.destroyAll([id]);

      dispatch({
        type: userDataDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.userData.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/user-data');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userDataDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: userDataDestroyActions.DESTROY_ALL_STARTED,
      });

      await UserDataService.destroyAll(ids);

      dispatch({
        type: userDataDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.userData.destroyAll.success'),
      );

      getHistory().push('/user-data');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userDataDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default userDataDestroyActions;
